<ng-container [ngSwitch]="brand">
  <i *ngSwitchCase="'visa'" class="fab fa-cc-visa"></i>
  <i *ngSwitchCase="'mastercard'" class="fab fa-cc-mastercard"></i>
  <i *ngSwitchCase="'amex'" class="fab fa-cc-amex"></i>
  <i *ngSwitchCase="'discover'" class="fab fa-cc-discover"></i>
  <i *ngSwitchCase="'diners'" class="fab fa-cc-diners-club"></i>
  <i *ngSwitchCase="'jcb'" class="fab fa-cc-jcb"></i>
</ng-container>
